import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'addMediaButton',
    'selectedImagePreview',
    'contentIdInput',
    'descriptionField',
    'generateButton',
    'duration',
    'cost',
  ];

  static values = {
    costInformation: Object, // JSON
  };

  connect() {
    this.updateButtonState();
    this.updateCost();
  }

  removeMedia() {
    this.addMediaButtonTarget.classList.toggle('hidden');
    this.selectedImagePreviewTarget.classList.toggle('hidden');
    this.contentIdInputTarget.value = '';
    this.updateButtonState();
  }

  updateButtonState() {
    if (this.hasGenerateButtonTarget) {
      const hasContent = this.contentIdInputTarget.value.trim() !== '';
      const hasDescription = this.descriptionFieldTarget.value.trim() !== '';

      if (hasContent && hasDescription) {
        this.generateButtonTarget.disabled = false;
        this.generateButtonTarget.classList.remove('opacity-50');
      } else {
        this.generateButtonTarget.disabled = true;
        this.generateButtonTarget.classList.add('opacity-50');
      }
    }
  }

  updateCost() {
    if (this.hasCostTarget) {
      const duration = this.durationTarget.value;
      const cost = this.costInformationValue[duration];
      this.costTarget.textContent = cost;
    }
  }
}
